import { Component, Prop, Vue } from 'nuxt-property-decorator';

@Component
export default class BaseLayoutMixin extends Vue {
	@Prop({
		type: Array,
		default() {
			return [];
		},
	})
	content!: { content: any[] };

	@Prop({
		type: Array,
		default() {
			return [];
		},
	})
	breadcrumbs!: Record<string, string>[];

	@Prop({
		type: Object,
		default() {
			return {};
		},
	})
	externalData?: any;
}
